import type { QueryClient } from '@tanstack/react-query';

import { Toaster } from 'sonner';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';

import { themeConfig, ThemeProvider } from 'src/theme';
import { LocaleProvider } from 'src/providers/locale.provider';
import { OrganizationProvider } from 'src/context/organization-context';

import { ProgressBar } from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import { AppInitializationGate } from 'src/components/app-initialization-gate';
import { SettingsDrawer, defaultSettings, SettingsProvider } from 'src/components/settings';

// Router context type - shared across all routes
export interface RouterContext {
  queryClient: QueryClient;
  auth: {
    isAuthenticated: boolean;
  };
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <SettingsProvider defaultSettings={defaultSettings}>
      <LocaleProvider>
        <ThemeProvider
          defaultMode={themeConfig.defaultMode}
          modeStorageKey={themeConfig.modeStorageKey}
        >
          <AppInitializationGate>
            <OrganizationProvider>
              <MotionLazy>
                <ProgressBar />
                <SettingsDrawer defaultSettings={defaultSettings} />
                <Toaster richColors expand visibleToasts={1} />
                <Outlet />
              </MotionLazy>
            </OrganizationProvider>
          </AppInitializationGate>
        </ThemeProvider>
      </LocaleProvider>
    </SettingsProvider>
  );
}
